import React from 'react';
// import logo from '../assests/images/Logo-andelBay-02.png'
import logo from '../assests/images/handelbay_logo_menu.png';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

// const navItems = [
// 	{
// 		caption: 'Regístrate gratis',
// 		href: 'https://handelbay.com/users/sign_up'
// 	},
// 	{
// 		caption: 'Ingresar',
// 		href: 'https://handelbay.com/users/sign_in'
// 	}
// ];

export default (props) => {
	return (
		// <header className="Header">
		//   <img src={ logo } alt="logo handelbay" className="Header-logo" />
		//   <nav className="Header-buttons">
		//     <ul className="Header-buttons">
		//       {
		//         navItems.map((item, index) =>(
		//           <li key={index}>
		//             <a className={index===1?'Header-button2':'Header-button'} href={item.href} target='_blank' rel="noopener noreferrer">
		//               { item.caption }
		//             </a>
		//           </li>

		//         ))
		//       }
		//     </ul>
		//   </nav>
		// </header>
		<header className="Header shadow">
			<Navbar collapseOnSelect expand="lg" className="Header-container container">
				<Navbar.Brand href="https://handelbay.com/">
					<img src={logo} alt="logo handelbay" className="Header-logo" />
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="responsive-navbar-nav">
					<Nav className="mr-auto downs float-left">
						<Nav.Link href="#" target="_blank" rel="noopener noreferrer">
							INICIO
							<span className="sr-only" />
						</Nav.Link>
						<NavDropdown title="EMPRESAS" id="collasible-nav-dropdown">
							<NavDropdown.Item
								href="https://handelbay.com.co/compradores"
								target="_blank"
								rel="noopener noreferrer"
							>
								Compradores
							</NavDropdown.Item>
							<NavDropdown.Item
								href="https://handelbay.com.co/proveedores"
								target="_blank"
								rel="noopener noreferrer"
							>
								Proveedores
							</NavDropdown.Item>
							<NavDropdown.Item
								href="https://handelbay.com.co/dual"
								target="_blank"
								rel="noopener noreferrer"
							>
								Dual
							</NavDropdown.Item>
						</NavDropdown>
						<Nav.Link href="https://handelbay.com.co/tarifas" target="_blank" rel="noopener noreferrer">
							TARIFAS
							<span className="sr-only" />
						</Nav.Link>
						<Nav.Link
							href="https://handelbay.com.co/porquehandelbay"
							target="_blank"
							rel="noopener noreferrer"
						>
							¿POR QUÉ HANDELBAY?
							<span className="sr-only" />
						</Nav.Link>
						<Nav.Link href="https://handelbay.com.co/alianzas" target="_blank" rel="noopener noreferrer">
							ALIANZAS
							<span className="sr-only" />
						</Nav.Link>
						<Nav.Link href="https://handelbay.com.co/blog" target="_blank" rel="noopener noreferrer">
							BLOG
							<span className="sr-only" />
						</Nav.Link>
					</Nav>
					<Nav className="float-right">
						<a
							href="https://app.handelbay.com.co/users/sign_up"
							className="Header-button"
							target="_blank"
							rel="noopener noreferrer"
						>
							REGÍSTRATE GRATIS
						</a>
						<a
							href="https://app.handelbay.com.co/users/sign_in"
							className="Header-button2"
							target="_blank"
							rel="noopener noreferrer"
						>
							INGRESAR
						</a>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		</header>
	);
};
